import { rankWith, schemaMatches, or, and, schemaSubPathMatches } from '@jsonforms/core';

export default rankWith(
  4, //increase rank as needed
  or(
    schemaMatches((schema) =>
      schema.hasOwnProperty('options') &&
      schema['options'].hasOwnProperty('money') &&
      schema['options']['money'] &&
      schema.hasOwnProperty('type') &&
      schema['type'] === 'number'
    ),
    schemaSubPathMatches('items', (schema, rootSchema) => {
      const resolvedSchema = schema;
      const outcome = resolvedSchema.hasOwnProperty('properties') &&
        resolvedSchema['properties'].length > 0 &&
        resolvedSchema['properties'].find(prop => prop.type === 'number' && prop.options?.money)
      console.log('outcome', outcome)
      return outcome
    })
  )
);
